import { useQuery } from '@tanstack/react-query'
import {
	type GetVisualVettingVolumeParams,
	httpGetVisualVettingVolume
} from '@/features/luxe-submissions/http/luxe-submissions.http'

export const VISUAL_VETTING_VOLUME_QUERY_KEY = 'visual-vetting-volume'

export const useGetVisualVettingVolume = (
	params: GetVisualVettingVolumeParams
) =>
	useQuery({
		queryKey: [VISUAL_VETTING_VOLUME_QUERY_KEY, params],
		queryFn: () => httpGetVisualVettingVolume(params)
	})
